import { Stack, InputAdornment, TextField } from '@mui/material';
import React from 'react';
import Iconify from './Iconify';

interface IProps {
  handleSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string | null;
  placeHolder?: string | null;
}
const SearchBar: React.FC<IProps> = ({ handleSearch, value, placeHolder }) => {
  return (
    <Stack
      spacing={2}
      direction={{ xs: 'column', sm: 'row' }}
      sx={{ py: 2.5, px: 3 }}
    >
      <TextField
        fullWidth
        value={value ?? ''}
        onChange={handleSearch}
        placeholder={placeHolder ?? 'Search...'}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <Iconify
                icon={'eva:search-fill'}
                sx={{ color: 'text.disabled', width: 20, height: 20 }}
              />
            </InputAdornment>
          ),
        }}
      />
    </Stack>
  );
};

export default SearchBar;
